export default image => {
  const { naturalWidth: width, naturalHeight: height } = image

  return { width, height }
}
